import type { Container, interfaces } from '../shared/inversify';

// 定义一个全局变量来保存 InversifyJS 容器实例
let _container: Container | undefined;

/**
 * 设置 InversifyJS 容器实例
 * @param container - InversifyJS 容器实例
 */
export function setContainer(container: Container) {
    _container = container;
}

/**
 * 获取之前设置的 InversifyJS 容器实例
 * @throws 如果容器尚未设置，会抛出错误
 * @returns InversifyJS 容器实例
 */
export function getContainer() {
    if (!_container) throw new Error('Container is not setup');
    return _container;
}

/**
 * Clears the container by setting it to undefined.
 */
export function clearContainer() {
    _container = undefined;
}

/**
 * 提取参数列表的尾部类型
 */
// type Tail<T extends any[]> = ((head: any, ...args: T) => any) extends ((head: any, ...tail: infer U) => any) ? U : [];

/**
 * 使用依赖注入从容器中获取实例并执行函数
 * @deprecated
 * @param fn - 接受容器实例和其他参数的函数
 * @returns 包装后的函数，接受其他参数并从容器中获取实例后执行原始函数
 */
export function bindContainer<T extends any[], R>(fn: (head, ...args: T) => R): (...args: T) => R {
    return (...args: T) => fn(getContainer(), ...args);
}

/**
 * Injects a service instance from the IoC container.
 *
 * @template T - The type of the service to inject.
 * @param identifier - The identifier of the service.
 * @returns The injected service instance.
 */
export function injectService<T>(identifier: interfaces.ServiceIdentifier<T>): T {
    const container = getContainer();
    return container.get<T>(identifier);
}

/**
 * Retrieves a named service from the container.
 *
 * @template T - The type of the service to retrieve.
 * @param identifier - The identifier of the service.
 * @param name - The name of the service.
 * @returns The named service.
 */
export function injectNamedService<T>(identifier: interfaces.ServiceIdentifier<T>, name: string | number | symbol): T {
    const container = getContainer();
    return container.getNamed<T>(identifier, name);
}
